import { PublicKey } from "@solana/web3.js";

export const TULIP_OWNER = new PublicKey("7vxeyaXGLqcp66fFShqUdHxdacp4k4kwUpRSSeoZLCZ4");

export const TULIP_STAKING_VAULT_ID = new PublicKey("82aST5b1s1ZEB8dP7sDLjLYNRC85sGKmjmYtyeWVnyjz");

export const STAKED_TULIP_MINT = new PublicKey("STuLiPmUCUtG1hQcwdc9de9sjYhVsYoucCiWqbApbpM");
